module.exports = __webpack_public_path__ + "img/menu-qudao.c502cd93.svg";